import styled from "styled-components";

export const TravelInsuranceDetailsStyleWrapper = styled.div`
min-height: 70vh;
.terms-agree-text {
    color: #818B9B;
    a {
        color: #6B47F5;
    }
}
.offer_wrapper{
    text-align: start;
    display: flex;
    width: 100%;
    padding: 1rem;
    gap: 1rem;
    border-radius: 0.5rem;
    border: 1px dashed var(--success-success, #5DB364);
    background: var(--White, #FFF);
    .offer_desc{
        .desc_txt1{
            color: var(--success-success, #5DB364);
            /* Heading En/Heading 5 */
            font-size: 1.25rem;
            font-style: normal;
            font-weight: 700;
            line-height: 130%; /* 1.625rem */
            letter-spacing: -0.0375rem;
        }
        .desc_txt2{
            color: var(--text-black, #1A1C1F);
            /* Paragraph En/S Paragraph */
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 400;
            line-height: 160%; /* 1.4rem */
        }
    }
    .offer_image img{
        height: 60px;
    }
}
.indexing{
    z-index:0;
}
@media only screen and (max-width: 576px) {
    .ar{
       h3{
            font-size: 1rem;
        }
    }
}
`;
